var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-img',{attrs:{"src":_vm.playlist.image,"alt":"Playlist Image","height":"200px"}}),_c('v-card-title',[_vm._v(_vm._s(_vm.playlist.name))]),_c('v-card-text',[_vm._v(_vm._s(_vm.playlist.user))]),_c('v-card-actions',[_c('v-btn',{attrs:{"rounded":""},on:{"click":_vm.explorePlaylist}},[_vm._v("...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }